/* eslint-disable no-nested-ternary */
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as Styled from './styles';
import * as SX from './sx';
import type { PlanBillingCycleProps as Props } from './types';

export const PlanBillingCycle = memo(({ className }: Props) => {
  const { yearly, isPaid } = usePlanCardContext();

  return (
    <Styled.Wrapper
      className={classnames('PlanBillingCycle', className)}
      sx={SX.root}
      gap={0.5}
    >
      <Typography
        variant="body4"
        fontWeight={400}
        color={isPaid ? 'common.white' : 'grey.500'}
      >
        {!isPaid
          ? 'Billed monthly'
          : yearly
          ? 'Billed Yearly. All Credits granted upfront.'
          : 'Billed monthly. Credits roll over up to 2X'}
        {}
      </Typography>
      <Typography
        variant="body4"
        fontWeight={700}
        color={isPaid ? 'common.white' : 'grey.500'}
        my={0.5}
      >
        {isPaid ? 'Per Months' : 'Always Free'}
      </Typography>
    </Styled.Wrapper>
  );
});

PlanBillingCycle.displayName = 'PlanBillingCycle';
